//==============================
// Animations
//==============================

$('.animation').waypoint(function(direction) {
  var thisItem = $(this.element);
  thisItem.addClass('animate');
}, {
  offset: '95%'
});
